import React from 'react';
import DroppableList from '../DroppableList';
import DraggableItem from '../DraggableItem';
import ServiceCard from './ServiceCard';
import { Card } from '../../ui';

/**
 * Componente que renderiza a lista de serviços agrupados por categorias
 * 
 * @param {Object} props - Propriedades do componente
 * @param {Array} props.servicesByCategory - Lista de categorias com seus serviços
 * @param {Function} props.onEditService - Função chamada ao editar um serviço
 * @param {Function} props.onDeleteService - Função chamada ao excluir um serviço
 * @param {Function} props.handleDragEnd - Função para processar o fim do drag and drop
 * @param {boolean} props.isSaving - Indica se há uma operação de salvamento em andamento
 */
const ServiceList = ({ 
  servicesByCategory, 
  onEditService, 
  onDeleteService, 
  handleDragEnd,
  isSaving = false 
}) => {
  return (
    <>
      {servicesByCategory.length > 0 ? (
        <div className={`space-y-2 ${isSaving ? 'opacity-70 pointer-events-none' : ''}`}>
          {servicesByCategory.map((category) => (
            <Card key={category.id} title={category.nome || 'Sem categoria'}>
              <div className="p-2">
                <DroppableList 
                  droppableId={category.id} 
                  type="service"
                  className="min-h-[40px]"
                >
                  {category.services.length > 0 ? (
                    category.services.map((service, index) => (
                      <DraggableItem key={service.id} id={service.id} index={index}>
                        <ServiceCard 
                          service={service} 
                          onEdit={onEditService} 
                          onDelete={onDeleteService}
                        />
                      </DraggableItem>
                    ))
                  ) : (
                    <div className="text-center py-2 text-gray-500 text-xs">
                      Arraste serviços para cá ou adicione um novo.
                    </div>
                  )}
                </DroppableList>
              </div>
            </Card>
          ))}
        </div>
      ) : (
        <div className="text-center py-6 bg-white shadow-sm rounded-xl">
          <p className="text-gray-500 text-sm">
            Nenhuma categoria encontrada. Crie uma categoria para adicionar serviços.
          </p>
        </div>
      )}
    </>
  );
};

export default ServiceList; 